import { useMediaQuery } from "@mui/material";
import { isUndefined } from "lodash";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { TOOLBAR_HEIGHT } from "../consts";
import { client } from "../generated/requests/services.gen";
import { BASE_THEME } from "../styles/theme";
const FLASHES_HEADER = "x-flask-flash";
const Snackbars = () => {
    const { enqueueSnackbar } = useSnackbar();
    const isMobile = useMediaQuery(BASE_THEME.breakpoints.down("md"));
    useEffect(() => {
        const props = isMobile
            ? {
                anchorOrigin: { horizontal: "center", vertical: "top" },
                style: { marginTop: TOOLBAR_HEIGHT },
                autoHideDuration: 4000,
            }
            : {
                anchorOrigin: { horizontal: "left", vertical: "bottom" },
                autoHideDuration: 4000,
            };
        const id = client.instance.interceptors.response.use(function (resp) {
            if (!(FLASHES_HEADER in resp.headers))
                return resp;
            for (const msg of JSON.parse(resp.headers[FLASHES_HEADER]))
                enqueueSnackbar(msg, { variant: "success", ...props });
            return resp;
        }, function (err) {
            const resp = err.response;
            if (isUndefined(resp))
                return err;
            if (FLASHES_HEADER in resp.headers) {
                for (const msg of JSON.parse(resp.headers[FLASHES_HEADER]))
                    enqueueSnackbar(msg, { variant: "error", ...props });
            }
            else {
                enqueueSnackbar("A server error occurred", {
                    variant: "error",
                    ...props,
                });
            }
            return Promise.reject(err);
        });
        return () => client.instance.interceptors.response.eject(id);
    }, [enqueueSnackbar, isMobile]);
    return React.createElement(React.Fragment, null);
};
export default Snackbars;
